import { render, staticRenderFns } from "./income.vue?vue&type=template&id=4a1a866f&"
import script from "./income.vue?vue&type=script&lang=js&"
export * from "./income.vue?vue&type=script&lang=js&"
import style0 from "./income.vue?vue&type=style&index=0&id=4a1a866f&lang=css&"
import style1 from "./income.vue?vue&type=style&index=1&id=4a1a866f&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a1a866f')) {
      api.createRecord('4a1a866f', component.options)
    } else {
      api.reload('4a1a866f', component.options)
    }
    module.hot.accept("./income.vue?vue&type=template&id=4a1a866f&", function () {
      api.rerender('4a1a866f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounting/income/income.vue"
export default component.exports